var _title, _g;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgAirtimeData = function SvgAirtimeData(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "24px",
    viewBox: "10 8 20 24",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "airtime_data")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "airtime_data",
    transform: "translate(13.000000, 9.000000)",
    fill: "#232323"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.90018752,7.9 L8.90018752,13.8661341 L10.499818,13.8661341 L10.499818,7.9 L8.90018752,7.9 Z M6.40009376,9.76439303 L6.40009376,13.8661341 L7.99972424,13.8661341 L7.99972424,9.76439303 L6.40009376,9.76439303 Z M3.9,11.6287861 L3.9,13.8661341 L5.49963048,13.8661341 L5.49963048,11.6287861 L3.9,11.6287861 Z",
    id: "Shape",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.9,0 C13.5016258,0 14.8,1.29837423 14.8,2.9 L14.8,2.9 L14.8,19.9 C14.8,21.5016258 13.5016258,22.8 11.9,22.8 L11.9,22.8 L2.9,22.8 C1.29837423,22.8 0,21.5016258 0,19.9 L0,19.9 L0,2.9 C0,1.29837423 1.29837423,0 2.9,0 L2.9,0 Z M13,17.299 L1.799,17.299 L1.8,19.9 C1.8,20.4670123 2.2290107,20.9338239 2.78014288,20.9935453 L2.9,21 L11.9,21 C12.5075132,21 13,20.5075132 13,19.9 L13,19.9 L13,17.299 Z M13,5.3 L1.799,5.3 L1.799,15.5 L13,15.5 L13,5.3 Z M11.9,1.8 L2.9,1.8 C2.29248678,1.8 1.8,2.29248678 1.8,2.9 L1.8,2.9 L1.799,3.5 L13,3.5 L13,2.9 C13,2.33298766 12.5709893,1.86617613 12.0198571,1.80645465 L11.9,1.8 Z",
    id: "Combined-Shape",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 7.9,
    cy: 18.9,
    r: 1
  }))))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAirtimeData, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/airtime_data.dd3443ee.svg";
export { ForwardRef as ReactComponent };